import React from "react";
import ReactECharts from "echarts-for-react";
import close from "../../minimise_button.png";
import moment from "moment";

export default class CChart extends React.Component {
  constructor(props) {
    super(props);
    console.log(props);
    this.state = {
      coptions: {
          title: {
          text:this.props.title,
          left: 'center',
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold',
            color: '#263238',
          },

        
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line", // Can be 'line', 'shadow', etc.
          },
          // formatter: (params) => {
          //   const { value } = params[0];
          //   return `${moment(value[0]).format("DD MMM YYYY")}: ${value[1].toFixed(3)} ${this.props.units}`;
          // },
          formatter: (params) => {
            const { data } = params[0];
            return `Date: ${moment(data[0]).format("DD MMM YYYY")}<br>${this.props.title}: ${data[1]} ${this.props.units}`;
          },
        },
        grid: {
          left: "10%",
          right: "10%",
          bottom: "15%",
          top: "15%",
        },
        xAxis: {
          type: "time",
          name:"Date",
          nameLocation: 'middle',
          nameGap: 25,
          nameTextStyle: {
            fontWeight: 'bold', // Makes the axis name bold
            fontSize: 12, // Adjusts font size (optional)
            color: '#000', // Sets text color (optional)
        },
        splitLine: {
          show: false, // Hides vertical grid lines
        },

          boundaryGap: false,
          axisLabel: {
            formatter: (value) => {
              return window.innerWidth > 1000
                ? moment(value).format("DD MMM YYYY")
                : moment(value).format("MMM YYYY");
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: (val) => val.toFixed(2),
          },
          name: this.props.yAxisTitle,
          nameLocation: "middle",
          nameTextStyle: {
            fontWeight: 'bold', // Makes the axis name bold
            fontSize: 12, // Adjusts font size (optional)
            color: '#000', // Sets text color (optional)
        },

          nameGap: 50,
        },
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100,
          },
        ],
        series: [
          {
            type: this.props.type === "bar" ? "bar" : "line",
            data: this.props.seriesData,
            smooth: true,
            symbol: 'none',

            lineStyle: {
              width: 2,
              color: '#26a0fc',
            },
            barStyle: {
              width: 2,
              color: '#26a0fc',
            },
            
          },
        ],
       
        toolbox: {
          feature: {
            // saveAsImage: {
            //   title: "Download",
            //   name: "vic_data",
            // },

            magicType: {
              type: ["bar", "line"],
              title: {
                line: "Line Chart",
                bar: "Bar Chart",
              },
            },
            restore: {
              title: "Restore",
            },
            myMinimize: {
              show: true,
              title: "Minimize",
              icon: `image://${close}`,
              onclick: this.props.toggleVisibleGraphPanel,
            },
          },
        },
      },
    };
  }

  updateData = (timeline) => {
    const dateOffset = {
      one_week: 7 * 24 * 60 * 60 * 1000,
    }[timeline] || 0;

    this.setState((prevState) => ({
      coptions: {
        ...prevState.coptions,
        xAxis: {
          ...prevState.coptions.xAxis,
          min: dateOffset
            ? new Date(this.props.maximumDate).getTime() - dateOffset
            : undefined,
          max: new Date(this.props.maximumDate).getTime(),
        },
      },
    }));
  };

  render() {
    console.log(this.props.chartloading);
    console.log(this.props.seriesData);
    console.log("this.props.titleprops.title cchart", this.props.chartdata);

    return (
      <React.Fragment id="chart" height="250px">
        <style>
          {`
            .toolbar {
              margin-left: 45px;
            }
            button {
              background: #fff;
              color: #222;
              border: 1px solid #e7e7e7;
              border-bottom: 2px solid #ddd;
              border-radius: 2px;
              padding: 4px 17px;
            }
            button.active {
              color: #fff;
              background: #008FFB;
              border: 1px solid blue;
              border-bottom: 2px solid blue;
            }
            button:focus {
              outline: 0;
            }
          `}
        </style>

        <ReactECharts
          option={this.state.coptions}
          notMerge={true}
          lazyUpdate={true}
          style={{ height: "100%", width: "100%" }}
        />
      </React.Fragment>
    );
  }
}
